//トップページ　キービジュアルスライダー
export function loginFunc() {
  var parm = location.search;
  if(parm.indexOf('?action=register') != -1 || $('.frontend-user-admin-login .error').length) {
    $('#registerform #wp-submit-confirmation').addClass('no-click');
    $('#registerform tbody tr:last-child td').append('<br><input type="checkbox" name="reprinted" id="reprinted" value="1"> 当サイトの内容、テキスト、画像等の無断転載・無断使用を行わないことに同意します。');
    $(document).on('click', '#reprinted', function() {
      if($(this).is(':checked')) {
        $('#registerform #wp-submit-confirmation').removeClass('no-click');
      } else {
        $('#registerform #wp-submit-confirmation').removeClass('no-click');
        $('#registerform #wp-submit-confirmation').addClass('no-click');
      }
    });  
  }
}
